import { Quotation } from 'Types';

export type QuotationData = {
  id: number;
  reference: string;
  createdAt: Date;
  date: string;
  unitPriceHT: string;
  dieselTaxPercentage: string;
  securityTaxPercentage: string;
  additionalServiceAmount: string;
  totalAmount: string;
  status: string;
  label: string;
};

export const formatQuotations = (quotations?: Quotation[]): QuotationData[] => {
  return (
    quotations?.map(
      ({
        id,
        reference,
        createdAt,
        date,
        unitPriceHT,
        dieselTaxPercentage,
        securityTaxPercentage,
        additionalServiceAmount,
        totalAmount,
        status,
      }) => ({
        id,
        reference,
        createdAt,
        date,
        unitPriceHT: `${unitPriceHT} €`,
        dieselTaxPercentage: `${dieselTaxPercentage} %`,
        securityTaxPercentage: `${securityTaxPercentage} %`,
        additionalServiceAmount:
          `${additionalServiceAmount.reduce((accumulator, currentValue) => {
            return accumulator + currentValue;
          }, 0)} €` || '/',
        totalAmount: `${totalAmount.toFixed(2)} €`,
        status: status.label,
        label: status.value,
      }),
    ) || []
  );
};
